/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
import {getProductsCount} from "../../../_helpers/DashboardRequests";

export function ProductsTileWidget({
  className,
  baseColor = "primary",
  widgetHeight = "150px",
}) {
  
  const [totalCount, setTotalCount] = useState(0);


  useEffect(() => {
    getProductsCount(true)
        .then(response => {
          setTotalCount(response.data.count)
        })
  }, []);
  
  return (
    <>
      <div
        className={`card card-custom bg-${baseColor} ${className}`}
        style={{ height: widgetHeight }}
      >
        <div className="card-body">
          <span className="svg-icon svg-icon-3x svg-icon-white ml-n2">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Layout/Layout-4-blocks.svg")} />
          </span>
          <div
            className={`text-inverse-${baseColor} font-weight-bolder font-size-h2 mt-3`}
          >
            {totalCount}
          </div>

          <a
            href="#"
            className={`text-inverse-${baseColor} font-weight-bold font-size-lg mt-1`}
          >محصولات فعال</a>
        </div>
      </div>
    </>
  );
}
